import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { planTypeOptions } from 'src/api/types';
import { PlanType } from 'src/graphql/_generated';

interface PlanTypeSelectProps extends Omit<Props, 'value' | 'options'> {
  value: PlanType | undefined | null;
  onChange: (value: { label: string; value: PlanType }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  filteredOptions?: PlanType[];
}

export const PlanTypeSelect: React.FC<PlanTypeSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select plan type',
  filteredOptions,
  ...rest
}) => {
  const options = filteredOptions?.length
    ? planTypeOptions.filter((option) => filteredOptions.includes(option.value))
    : planTypeOptions;

  const selectedValue = value ? _.find(options, (o) => o.value === value) : null;

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="plan-type-select"
        name="planType"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
